<template>
    <div>
        <div class="flex justify-between items-center">
            <div class="w-3/4">
                <h1 class="text-5xl text-teal-800 truncate">
                    {{ page.url_short }}
                </h1>
            </div>

            <div class="flex justify-end w-1/4">
                <inertia-link
                    :href="route('admin.scraperpages.download', page.id)"
                    method="patch"
                    class="group bg-white px-3 py-2 rounded text-teal-800 hover:text-teal-200 hover:bg-teal-800"
                    @click="setTempLoading('download')"
                    preserve-scroll
                    preserve-state
                >
                    <i class="fad mr-1 text-teal-600 group-hover:text-teal-200" :class="loading == 'download' ? 'fa-spinner fa-pulse' : 'fa-download'"></i>Download
                </inertia-link>

                <!-- <inertia-link
                    :href="route('admin.scraperpages.analyze', page.id)"
                    method="patch"
                    class="ml-5 group bg-white px-3 py-2 rounded text-teal-800 hover:text-teal-200 hover:bg-teal-800"
                    @click="setTempLoading('analyze')"
                    preserve-scroll
                    preserve-state
                >
                    <i
                        class="fad mr-1 text-teal-600 group-hover:text-teal-200"
                        :class="loading == 'analyze' ? 'fa-spinner fa-pulse' : 'fa-robot'"
                    ></i
                    >Analyze
                </inertia-link> -->

                <inertia-link
                    :href="route('admin.scraperpages.parse', page.id)"
                    method="patch"
                    class="ml-5 group bg-white px-3 py-2 rounded text-teal-800 hover:text-teal-200 hover:bg-teal-800"
                    @click="setTempLoading('parse')"
                    preserve-scroll
                    preserve-state
                >
                    <i class="fad mr-1 text-teal-600 group-hover:text-teal-200" :class="loading == 'parse' ? 'fa-spinner fa-pulse' : 'fa-layer-plus'"></i>Parse & persist
                </inertia-link>
            </div>
        </div>

        <div class="flex flex-wrap items-center justify-between bg-white px-6 py-3 rounded mb-5">
            <div v-if="page.job_offer">
                <inertia-link :href="route('admin.joboffers.show', page.job_offer.id)" class="hover:underline">
                    <i class="fal fa-file-user mr-1"></i>Vacature:
                    {{ page.job_offer.id }}
                </inertia-link>
            </div>
            <div>
                <i class="fad fa-eye mr-1"></i>
                First seen:
                {{ moment(page.created_at).fromNow(false) }}
            </div>
            <div>
                <i class="fad fa-eye mr-1"></i>
                Last seen:
                {{ moment(page.last_seen_at).fromNow(false) }}
            </div>
            <div>
                <i class="fad fa-download mr-1"></i>
                {{ moment(page.last_downloaded_at).fromNow(false) }}
            </div>
            <div>
                <i class="fad fa-robot mr-1"></i>
                {{ moment(page.last_analyzed_at).fromNow(false) }}
            </div>
            <div>
                <i class="fad fa-layer-plus mr-1"></i>
                {{ moment(page.last_parsed_at).fromNow(false) }}
            </div>
            <!-- <div>{{ page.url }}</div> -->
        </div>

        <div class="flex" style="height: 600px;">
            <!-- Content Preview -->
            <div class="w-1/3 h-full">
                <h2 class="text-xl mb-1">
                    Page content
                </h2>
                <div class="overflow-y-auto p-2 rounded h-full bg-gray-800">
                    <pre class="m-0 rounded"><code v-if="page.content" v-text="page.content" class="text-xs" ></code></pre>
                </div>
            </div>

            <div class="w-1/3 ml-5">
                <h2 class="text-xl mb-1">
                    Parsed data
                </h2>

                <div class="bg-white px-5 py-5 rounded overflow-y-auto h-full">
                    <div v-if="parsed">
                        <div v-if="analysis">
                            <!-- <div v-if="analysis.published" class="bg-green-200 px-3 py-1 mb-3 rounded">
                                <i class="fad fa-leaf mr-1"></i>Groene vacature! (score:{{ analysis.score }})
                            </div>
                            <div v-else="analysis.published" class="bg-red-100 px-3 py-1 mb-3 rounded">
                                <i class="fad fa-leaf mr-1"></i>Geen groene vacature (score:{{ analysis.score }})
                            </div> -->
                        </div>

                        <div class="flex justify-between items-start">
                            <h2 class="text-xl mb-3">
                                {{ parsed.title }}
                            </h2>
                            <span><i class="fad fa-leaf mr-1"></i> score:{{ analysis.score }}</span>
                        </div>

                        <div class="bg-gray-100 p-3 flex flex-wrap items-center justify-left rounded">
                            <div class="mr-5">
                                <i class="fal fa-building mr-1"></i>{{ parsed.company ? parsed.company.name : "onbekend" }}
                                <i class="ml-1 fad" :class="parsed.company.id ? 'fa-check' : 'fa-question'"></i>
                            </div>

                            <div class="mr-5">
                                <i class="fal fa-map-marker-alt mr-1"></i>
                                {{ parsed.place ? parsed.place.name : "onbekend" }}
                                <i class="ml-1 fad" :class="parsed.place.id ? 'fa-check' : 'fa-question'"></i>

                                <!--                                 {{ parsed.region ? parsed.region.name : "onbekend" }}
                                <i class="ml-1 fad" :class="parsed.region.id ? 'fa-check' : 'fa-question'"></i> -->
                            </div>

                            <div class="mr-5"><i class="fal fa-clock mr-1"></i>{{ parsed.hours || "onbekend" }}</div>
                            <div class="mr-5"><i class="fal fa-hand-holding-usd mr-1"></i>{{ parsed.salary || "onbekend" }}</div>
                        </div>

                        <div class="flex flex-wrap items-center mt-3">
                            <div>
                                <i class="fad fa-tags"></i>
                                <span class="font-bold mr-1">Tags:</span>
                            </div>

                            <div v-for="(tag, key) in parsed.tags" class="mr-1 mb-1 px-3 py-1 rounded" :class="tag.id ? 'bg-teal-300' : 'bg-red-300'">
                                <i
                                    class="fal mr-1"
                                    :class="{
                                        'fa-map-marker-alt': tag.category === 'woonplaats' || tag.category === 'provincie',
                                        'fa-user-md': tag.category === 'sector',
                                        'fa-clock': tag.category === 'dienstverband',
                                        'fa-graduation-cap': tag.category === 'opleidingsniveau'
                                    }"
                                ></i>
                                {{ tag.name }}
                                <i class="ml-1 fad" :class="tag.id ? 'fa-check' : 'fa-question'"></i>
                            </div>
                        </div>

                        <div class="styled-content mt-3" v-html="parsed.description"></div>
                    </div>
                </div>
            </div>

            <div class="w-1/3 ml-5">
                <h2 class="text-xl mb-1">
                    Opgeslagen vacature
                </h2>
                <div class="bg-white px-5 py-5 rounded overflow-y-auto h-full">
                    <job-offer v-if="page.job_offer" :job-offer="jobOffer" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import "@/../../node_modules/highlight.js/styles/atom-one-dark.css";
import hljs from "highlight.js";
import JobOffer from "@/admin/Components/JobOffers/JobOffer";

export default {
    metaInfo: {
        title: "ScrapePages"
    },

    layout: Layout,

    mixins: [Helpers],

    components: {
        Breadcrumbs,
        JobOffer
    },

    props: {
        page: Object,
        parsed: Object,
        jobOffer: Object,
        analysis: Object
    },

    watch: {
        page() {
            this.highlight();
        }
    },

    data() {
        return {};
    },

    methods: {
        highlight() {
            setTimeout(() => {
                document.querySelectorAll("pre code").forEach(block => {
                    hljs.highlightBlock(block);
                });
            }, 300);
        }
    },

    mounted() {
        this.highlight();
    }
};
</script>

<style scoped>
.hljs {
    background: #2d3748;
}
</style>
